import { Color } from '../../../enums/color'

export const TABLE_COLOR = Color.White
export const TABLE_ROW_HOVER_COLOR = Color.Lavender50
